// ==== FOOTER: Filter Cases ==== //

;(function($){
  // Global namespace
  var caseFilters = caseFilters || {};
  var mwCases     = mwCases     || {};

  $(function(){
    // Global variables
    var $body    = $('body'),
        $filters = $('#cases-filters'),
        $backnav = false,
        screen_w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    caseFilters.init = function() {
      $filters.find('input[name="method[]"]').bind('click', function() {
        mwCases.ajaxFilterCases();
      });

      $filters.find('input[name="type[]"]').bind('click', function() {
        mwCases.ajaxFilterCases();
      });

      $('.range_slider').each(function (index, value) {
        var $this = $(this);
        $this.ionRangeSlider({
          type: 'double',
          grid: false,
          force_edges: true,
          min: $this.data('min'),
          max: $this.data('max'),
          step: $this.data('step'),
          prettify_separator: $this.data('sep'),
          postfix: $this.data('post'),
          max_postfix: $this.data('maxpost'),
          onFinish: function (data) {
            if($body.hasClass('page-template-cases')) mwCases.ajaxFilterCases();
          },
        });
      });


      if (screen_w < 890) {
        $filters.find('h5').on('click', function() {
          var $this = $(this);
          var state = $this.parent('.cases--wrap__filters__filter').attr('aria-expanded');

          if (state == 'true') {
            $this.parent('.cases--wrap__filters__filter').attr('aria-expanded', false);
           } else {
            $filters.find('.cases--wrap__filters__filter').attr('aria-expanded', false);
            $this.parent('.cases--wrap__filters__filter').attr('aria-expanded', true);
           }
        });
      }
    };

    mwCases.init = function(parent, children) {

      /* ================================
       * Init global
       * ================================ */

      // Hook browser history pop
      window.onpopstate = function(ev) {
        loadAJXpage(document.location, false);
        $backnav = true;
        //console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
      };

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          'event': 'fireRemarketingTag',
          'google_tag_params': {
            'listing_id': mwCasenumbers,
            'listing_pagetype': 'searchresults',
          }
        });
      }

      caseFilters.init();

    };

    if($body.hasClass('page-template-cases')) mwCases.init();

    mwCases.ajaxFilterCases = function() {
      var searchParts = [];
      if (typeof search_string !== 'undefined') searchParts.push('soeg=' + encodeURIComponent(search_string));
      if (typeof shopno_string !== 'undefined') searchParts.push('shopno=' + encodeURIComponent(shopno_string));

      var search = searchParts.length ? ('?' + searchParts.join('&') + '&') : '?';
      var filterUrl = window.location.href.split(/[?#]/)[0] + search + $filters.serialize() + '#cases-wrap';

      if($filters.is('[disabled=disabled]')) return;

      $body.addClass('loading');
      $filters.attr('disabled', true);
      $filters.find('input').attr('disabled', true);
      $filters.find('.irs--flat').attr('disabled', true);

      loadAJXpage(filterUrl,true);

    };

    var jqxhr = '';
    function loadAJXpage(href,pushstate) {
      if(!href) return false;
      if(jqxhr) jqxhr.abort();

      jqxhr = $.ajax({
          method: 'GET',
          url: href,
          data: {},
          dataType: 'html'
        }
      )
      .done(function(html) {
        loadAJXcontent(html,href,pushstate);
      })
      .fail(function() {
        //document.location = href;
      })
      .always(function() {});
    }

    var load_timer = '';
    function loadAJXcontent(html,href,pushstate) {
      var newHtml    = $(html);
      var newContent = newHtml.find('#cases-wrap');
      var count      = newHtml.find('.cases--wrap__total');
      var filters    = newHtml.find('#cases-filters');
      var pagination = newHtml.find('.numeric-navigation');

      $body.find('#cases-wrap').replaceWith(newContent);
      updateAjaxFilterCount(count);
      updateAjaxPagination(pagination);

      // Save browser history state
      if (pushstate) {
        var newTitle = newHtml.filter('title').text();
        history.pushState({'jspageload':true}, newTitle, href);
        document.title = newTitle;
      }

      //if ($backnav) updateAjaxFilters(filters);

      //if ($body.hasClass('home')) app.projectGrid();

      clearTimeout(load_timer);
      load_timer = setTimeout(function() {
        $body.removeClass('loading');
        $filters.attr('disabled', false);
        $filters.find('input').attr('disabled', false);
        $filters.find('.irs--flat').attr('disabled', false);
      }, 200);

      if (typeof ga !== 'undefined') {
        ga('send', 'pageview', href);
      }
    }

    function updateAjaxFilterCount(itemsTotal) {
      var filterCount = $('.cases--wrap__total');
      $body.find(filterCount).replaceWith(itemsTotal);
    }

    function updateAjaxFilters(newFilters) {
      $filters.replaceWith(newFilters);
    }

    function updateAjaxPagination(newPagination) {
      var pagination = $('#cases-nav');
      $body.find(pagination).html(newPagination);
    }

  });

}(jQuery));
